import "./App.css";

import { ApolloProvider } from "@apollo/client";
import { Provider } from "react-redux";
import Routing from "./routes";
import store from "./store";
import { client } from "./utils/client";

function App() {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <Routing />
      </Provider>
    </ApolloProvider>
  );
}

export default App;
